export default __webpack_public_path__ + "static/media/37.40c438bc.jpg";